import React from "react";
import AdminDashboardView from "./AdminDashboardView";

const AdminPage = () => {
    return <AdminDashboardView />;
};

export default AdminPage;